import { connect } from "react-redux";
import React, { useState } from "react";
import { InputNumber, Modal } from "antd";

import ConfirmButton from "../../../components/buttons/ConfirmButton";

import { setClientAmounts } from "../../../modules/presence/api/api";
import { currentClientSelector } from "../../../redux/selectors/auth";

const ClientRegularBonusForm = ({ getLimitsBonusesList, closeModal, token, client_id }) => {
  const [monthlyAmount, setMonthlyAmount] = useState(0);
  const [quarterlyAmount, setQuarterlyAmount] = useState(0);

  const onSubmit = async () => {
    const dataToSend = {
      monthly_amount: monthlyAmount,
      quarterly_amount: quarterlyAmount,
      client_id
    };
    try {
      const { message, ok } = await setClientAmounts(dataToSend, token);
      Modal.confirm({ title: ok ? "Succés" : "Echec", content: message });
      getLimitsBonusesList();
      closeModal();
    } catch (e) {
      console.log("e", e, e.response);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant de la prime mensuelle</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={monthlyAmount}
          onChange={setMonthlyAmount}
        />
      </div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant de la prime trimestrielle</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={quarterlyAmount}
          onChange={setQuarterlyAmount}
        />
      </div>
      <div className="pt-6 flex justify-center mt-6">
        <ConfirmButton label={"Appliquer"} large={true} onClick={onSubmit} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const client = currentClientSelector(state);
  return {
    token: state.auth.token,
    client_id: client.id
  };
};

export default connect(mapStateToProps)(ClientRegularBonusForm);



// WEBPACK FOOTER //
// src/containers/admin/premium/ClientRegularBonus.form.js